import React, { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import AvisBloc from "../../blocs/AvisBloc";
import BlocTitleText from "../../components/blocTitleText";
import EmplacementEtablissement from "../../components/emplacement";
import Equipe from "../../components/equipe";
import EtablissementGallery from "../../components/EtablissementGallery";
import EtablissementHeader from "../../components/EtablissementHeader";
import EtablissementServices from "../../components/EtablissementServices";
import Footer from "../../components/Footer";
import SixBlocks from "../../components/SixBlocks";
import TopHeader from "../../components/TopHeader";
import {
  fetchEtablissementById,
  fetchEtablissementsByTag,
  getRecentlyVisited
} from "../../store/slices/etablissementSlice";
import Faqs from "../../blocs/Faqs";
import BlocEtablissement from "./blocsEtablissement";
import OpeningHours from "../../components/OpeningHours";
import Skeleton from "react-loading-skeleton";
import { resetDetailsRDV } from "../../store/slices/rendezVousSlice";

// Fake Etablissement data for testing

const SingleEtablissement = ({ etablissement }) => {
  const params = useParams();
  const location=useLocation()
//  console.log(location)
  let from="search"
   from=location?.state && location?.state?.from
   
  const dispatch = useDispatch();
  const {
    selectedEtablissement,
    status,
    error,
    etablissementsByTag,
    tagStatus,
  } = useSelector((state) => state.etablissements);
  const { faqs } = useSelector((state) => state.blocs);

  // const idEtablissement=location?.state?.idEtablissement || params?.id
  const idEtablissement=params?.id
  const getSortedServices = () => {
    if (!selectedEtablissement?.services) return [];
    
    return selectedEtablissement.services
      .slice()
      .sort((a, b) => {
        // Priorité 1 : ordre explicite
        if (a.order !== undefined && b.order !== undefined) {
          return a.order - b.order;
        }
        // Priorité 2 : ordre alphabétique
        return a.nom.localeCompare(b.nom);
      });
  };
  useEffect(() => {

    if (idEtablissement) {
      //if (params?.id != selectedEtablissement?.id) {
        dispatch(fetchEtablissementById(idEtablissement)).then(
          dispatch(getRecentlyVisited())
        );
     // }
    }
  }, [idEtablissement]);
  useEffect(() => {
    return () => {
      dispatch(resetDetailsRDV());
    };
  }, []);
  useEffect(() => {
  
      if (selectedEtablissement?.domaine_activite) {
        dispatch(
          fetchEtablissementsByTag(
            `type=category&category_id=${selectedEtablissement.domaine_activite}&current_etablissement_id=${selectedEtablissement?.id}`
          )
        );
        // console.log(etablissementsByTag);
      }
    
  }, [selectedEtablissement?.domaine_activite]);
  // Add this useEffect to log when etablissementsByTag changes
const pageTitle =
  status === "succeeded" && selectedEtablissement?.nom
    ? `${selectedEtablissement.nom} à ${selectedEtablissement.ville || ''} - Prenez rendez-vous sur Twyny`
    : "Détails de l'établissement | Twyny";

const pageDescription =
  status === "succeeded" && selectedEtablissement?.nom
    ? `Découvrez ${selectedEtablissement.nom} à ${selectedEtablissement.ville || ''}. Consultez les services, avis clients, horaires et prenez rendez-vous en ligne facilement.`
    : "Consultez les services, horaires d'ouverture, l'emplacement, les avis et prenez rendez-vous en ligne.";

  return (
    <>
      <HelmetProvider>
        <Helmet>
           <title>{pageTitle}</title>
          <meta name="description" content={pageDescription} />
        </Helmet>
      </HelmetProvider>
      <TopHeader btn={true} />
      <div className="container single-etablissement">
        <div className="row">
          <EtablissementHeader
            etablissement={selectedEtablissement}
            status={status}
            from={from}
          />
          <EtablissementGallery
            photos={selectedEtablissement?.photos}
            status={status}
          />
        </div>
        <div className="row mt-24">
          <div className="col-md-8">
            <EtablissementServices
              services={getSortedServices()}
              horaires={selectedEtablissement?.horaires}
              // disponibilites={etablissement?.disponibilite}
              status={status}
              etablissement={selectedEtablissement}
            />
            {/* <hr /> */}
            <EmplacementEtablissement
              title={
                status === "loading" ? (
                  <Skeleton width={300} />
                ) : (
                  `Où se situe ${selectedEtablissement?.nom} ? `
                )
              }
              adr={status === "loading" ? (
                <Skeleton width={300} />
              ) : (selectedEtablissement?.adresse_postale ? `${selectedEtablissement?.adresse_postale} , ${selectedEtablissement?.code_postal} ${selectedEtablissement?.ville}`:'' ) }
              LatLng={{
                id: 1,
                lat: selectedEtablissement?.lat,
                lng: selectedEtablissement?.lng,
              }}
            />
            {selectedEtablissement?.description ? (
              <BlocTitleText
                title={"À propos"}
                text={selectedEtablissement?.description}
              />
            ) : (
              ""
            )}

          {selectedEtablissement?.equipes?.length>0 && 
          <Equipe members={selectedEtablissement?.equipes} />}  

            {selectedEtablissement?.reviews?.length > 0 && (
              <AvisBloc
                status={status}
                title="Avis"
                nbStars={parseFloat(selectedEtablissement?.average_rating)}
                avis={selectedEtablissement?.reviews}
                reviews_by_prestation={
                  selectedEtablissement?.reviews_by_prestation
                }
              />
            )}
            <SixBlocks col={4} />
          </div>
          <div className="col-md-4" style={{ position: "sticky", top: "90px", height: "fit-content" }}>
            <OpeningHours
              horaires={selectedEtablissement?.horaires}
              disponibilites={selectedEtablissement?.availability_next_8_days}
              status={status}
              services={selectedEtablissement?.services}
              etablissement={etablissement}
            />
          </div>
        </div>
        <Faqs faqs={faqs} status={status} />
        {etablissementsByTag?.length > 0 ? (
          <BlocEtablissement
            title={"Découvrez sur Twyny"}
            status={tagStatus}
            etablissements={etablissementsByTag || []}
            showCount={4} // Only show 4 newest
          />
        ) : (
          ""
        )}
        <div className="ht-80"></div>
      </div>

      {/* </div> */}

      <Footer />
    </>
  );
};

export default SingleEtablissement;
